import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import {
  Items,
  ProductParamInput,
  ScheduleParam,
} from 'containers/ProductRegist/hooks/types';

export interface DateFormat {
  date: number;
  time: number;
}

export interface TermDate {
  startDate: string;
  endDate: string;
  durationDate: string;
}

export const useDateAdditionalHooks = (
  scheduleItem: ScheduleParam,
  handleSetScheduleItem: (changes: Record<string, any>) => void,
) => {
  const twentyFourHoursMs = 24 * 60 * 60 * 1000;

  const [isAppliedAllItems, setIsAppliedAllItems] = useState<boolean>(
    scheduleItem.id ? scheduleItem.appliedAllItems : true,
  );
  const [selectedItems, setSelectedItems] = useState<Items[]>([]);
  const [termDate, setTermDate] = useState<TermDate>({
    startDate: '',
    endDate: '',
    durationDate: '1',
  });
  const [endDateFormat, setEndDateFormat] = useState<string>('3day');
  const [endDueDate, setEndDueDate] = useState<DateFormat>({
    date: 0,
    time: 0,
  });
  const [isOverDay, setIsOverDay] = useState<boolean>(
    scheduleItem.term.duration > twentyFourHoursMs,
  );
  const [isOpenDeleteDialog, setIsOpenDeleteDialog] = useState<boolean>(false);

  // 모든 옵션 / 개별 옵션 선택
  const handleSetIsAppliedAllItems = (isAppliedAllItems: boolean) => {
    if (isAppliedAllItems) {
      handleSetScheduleItem({
        appliedAllItems: true,
        itemParamIds: [],
      });
    }

    if (!isAppliedAllItems) {
      handleSetScheduleItem({
        appliedAllItems: false,
      });
    }

    setIsAppliedAllItems(isAppliedAllItems);
  };
  console.log('scheduleItem', scheduleItem);
  console.log('selectedItems', selectedItems);

  // 일정 옵션 추가 로직
  const handleAddOptions = (item: Items) => {
    if (scheduleItem.appliedAllItems) {
      return;
    }

    const isSelected = scheduleItem.itemParamIds.includes(item.paramId);

    if (isSelected) {
      const filterItem = scheduleItem.itemParamIds.filter(
        filterItem => filterItem !== item.paramId,
      );

      setSelectedItems(
        selectedItems.filter(filterItem => filterItem.paramId !== item.paramId),
      );

      handleSetScheduleItem({
        itemParamIds: filterItem,
      });
      return;
    }

    console.log(selectedItems, scheduleItem);

    setSelectedItems([...selectedItems, item]);
    handleSetScheduleItem({
      itemParamIds: [...scheduleItem.itemParamIds, item.paramId],
    });
  };

  // 일정 모든 옵션 추가 로직(중지, 삭제 상태 제외)
  const handleAddAllOptions = (itemList: Items[]) => {
    if (
      // !scheduleItem.appliedAllItems &&
      scheduleItem.itemParamIds.length === 0
    ) {
      /* 삭제, 중지를 제외한 선택 가능한 옵션 id 리스트 */
      const itemParamIdList = itemList.map(item => {
        if (!item?.status || ['OPENED', 'EDITING'].includes(item?.status)) {
          return item.paramId;
        }
      });

      itemList.forEach(item => {
        if (!item?.status || item?.status === 'OPENED') {
          setSelectedItems(pre => {
            if (pre.some(preItem => preItem.paramId === item.paramId)) {
              return pre;
            }

            return [...pre, item];
          });
        }
      });

      handleSetScheduleItem({
        itemParamIds: [...itemParamIdList],
      });
    }
  };

  const handleSetOverDay = () => {
    if (isOverDay) {
      setTermDate({ ...termDate, durationDate: '0' });
      setIsOverDay(false);

      return;
    }

    setIsOverDay(true);
  };

  const handleSetTermDate = (changes: Record<string, any>) => {
    setTermDate(prev => ({
      ...prev,
      ...changes,
    }));
  };

  const handleSetEndDateFormat = (dateFormat: string) => {
    setEndDateFormat(dateFormat);

    if (
      dateFormat === 'select' &&
      endDueDate.date === 0 &&
      endDueDate.time === 0
    ) {
      setEndDueDate({ date: 0, time: 1 });
    }
  };

  const handleSetEndDueDate = (changes: Record<string, any>) => {
    setEndDueDate(prev => ({
      ...prev,
      ...changes,
    }));
  };

  useEffect(() => {
    if (scheduleItem.term.startedAt) {
      setTermDate({
        ...termDate,
        startDate: dayjs(scheduleItem.term.startedAt).format('HH:mm'),
        endDate: dayjs(
          scheduleItem.term.startedAt + scheduleItem.term.duration,
        ).format('HH:mm'),
        durationDate:
          scheduleItem.term.duration &&
          Math.round(scheduleItem.term.duration / twentyFourHoursMs).toString(),
      });
    }
  }, [scheduleItem.term]);

  return {
    isAppliedAllItems,
    isOverDay,
    termDate,
    endDateFormat,
    endDueDate,
    selectedItems,
    isOpenDeleteDialog,
    setTermDate,
    setIsOpenDeleteDialog,
    handleSetIsAppliedAllItems,
    handleAddOptions,
    handleAddAllOptions,
    handleSetOverDay,
    handleSetTermDate,
    handleSetEndDueDate,
    handleSetEndDateFormat,
  };
};
